/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Usage_DescriptionInputs */

const en_settings_overview_usage_description = /** @type {(inputs: Settings_Overview_Usage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API calls this month`)
};

const zh_settings_overview_usage_description = /** @type {(inputs: Settings_Overview_Usage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本月 API 调用次数`)
};

/**
* | output |
* | --- |
* | "API calls this month" |
*
* @param {Settings_Overview_Usage_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_overview_usage_description = /** @type {((inputs?: Settings_Overview_Usage_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Usage_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_overview_usage_description(inputs)
	return zh_settings_overview_usage_description(inputs)
});
export { settings_overview_usage_description as "settings.overview.usage_description" }